import { Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import QuoteList from "./components/list/index";
import { ToastContainer, Breadcrumbs } from "../../components/Common";
import useAuthUser from "../../common/hooks/authUser";
import { useEffect } from "react";

const QuotesPage = () => {
    const { user, isAdmin } = useAuthUser();
    const pageTitle = isAdmin ? "Quotes" : "My Quotes";


    const navigate = useNavigate();


    const onNewQuoteClicked = () => {
        navigate('/quotes/create');
    };

    useEffect(() => {
        document.title = pageTitle;
    }, [isAdmin]);

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title={pageTitle}
                >
                    <button
                        className="ms-4 btn btn-primary"
                        onClick={onNewQuoteClicked}
                    >CREATE NEW QUOTE
                    </button>
                </Breadcrumbs>
                <QuoteList
                    isAdmin={isAdmin}
                    userId={user.id}
                />
                <ToastContainer />
            </Container>
        </div>
    );
};

export default QuotesPage;
